"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('bug', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M20,38 C32,38 34,27.5323633 34,24 C34,20.837862 34,16.1711953 34,10 L6,10 C6,13.442296 6,18.1089627 6,24 C6,27.450596 8,38 20,38 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M3.55271368e-15,4 L6,10",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M40,4 L34,10",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M0,23 L6,23",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M40,23 L34,23",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M3,40 L9,34",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M37,40 L31,34",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M20,38 L20,10",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M10.920475,35.0408965 C13.002464,36.7831828 15.9245088,38 20,38 L20,38 C24.1112534,38 27.0487287,36.7713317 29.1341392,35.0138386",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M28,8.33333333 C28,3.73096042 24.418278,0 20,0 C15.581722,0 12,3.73096042 12,8.33333333 L12,10 L28,10 L28,8.33333333 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }))));
});

exports.default = _default;